import Mouse from './Mouse';

export default {
  __init__: [ 'mouse' ],
  mouse: [ 'type', Mouse ]
};
